// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bcc_a bhc_a bhc_r bhc_j","ModeratorInvitationListItem__left":"bcc_b bhc_a bhc_j","ModeratorInvitationListItem__note":"bcc_c bhc_fm"};